import React from 'react';
export type CasetivityViewContext = 'PROCESS' | 'PROCESS_TASK' | 'ENTITY' | 'START_FORM';
const casetivityViewContext = React.createContext<CasetivityViewContext>('ENTITY');
export default casetivityViewContext;
